<template>
  <el-dialog class="edit-enterpise" title="合同编辑" width="480px" :close-on-click-modal="false" :visible.sync="visible">
    <el-form ref="form" label-width="100px" size="small" :model="form" :rules="rules">
      <el-form-item label="合同编号" prop="contractNo">
        <el-input placeholder="请输入合同编号" maxlength="30" v-model="form.contractNo"></el-input>
      </el-form-item>
      <el-form-item label="合同名称" prop="contractName">
        <el-input placeholder="请输入合同名称" maxlength="30" v-model="form.contractName"></el-input>
      </el-form-item>
      <el-form-item label="发票类目" prop="invoiceClassId">
        <el-select placeholder="请选择发票类目" v-model="form.invoiceClassId" v-el-select-loadmore="handleLoadMore">
          <el-option v-for="(item, index) in invoiceClassList" :key="index" :label="item.invoiceClassName" :value="item.invoiceClassId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="起止时间" prop="timeRang">
        <el-date-picker v-model="form.timeRang" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="合同状态" prop="contractStatus">
        <el-select placeholder="请选择合同状态" v-model="form.contractStatus" v-el-select-loadmore="handleLoadMore">
          <el-option v-for="(item, index) in contractStatusEnum" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合同生成时间" prop="generateTime">
        <el-date-picker v-model="form.generateTime" placeholder="请选择合同生成时间"> </el-date-picker>
      </el-form-item>
      <el-form-item label="合同签署时间" prop="signTime">
        <el-date-picker v-model="form.signTime" placeholder="请选择合同生成时间"> </el-date-picker>
      </el-form-item>
      <el-form-item label="合同" prop="fileId">
        <el-upload
          ref="uploadRef"
          action="/paywages/api/file/upload"
          :limit="1"
          :file-list="fileList"
          :on-remove="handleRemove"
          :http-request="handleUpload"
        >
          <el-button size="mini" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="invoice-footer">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from '@/api/api';
import { contractStatusEnum } from '@/utils/enum';

export default {
  name: 'addInvoceApply',
  data() {
    return {
      visible: false,
      contractStatusEnum,

      invoiceClassList: [],
      classCount: 0,
      classPage: {
        index: 1,
        size: 10,
      },

      form: {
        contractId: 1,
        contractNo: '',
        contractName: '',
        invoiceClassId: '',
        contractStatus: '',
        generateTime: '',
        signTime: '',
        timeRang: '',
        fileId: '',
      },
      rules: {
        contractNo: [{ required: true, message: '请输入合同编号', trigger: 'change' }],
        contractName: [{ required: true, message: '请输入合同名称', trigger: 'change' }],
        invoiceClassId: [{ required: true, message: '选择发票类目', trigger: 'change' }],
        contractStatus: [{ required: true, message: '选择发票状态', trigger: 'change' }],
        fileId: [{ required: true, message: '请上传合同文件', trigger: 'change' }],
      },

      fileList: [],
    };
  },
  methods: {
    show(contrcatInfo) {
      this.form.contractId = contrcatInfo.contractId;
      this.form.contractNo = contrcatInfo.contractNo;
      this.form.contractName = contrcatInfo.contractName;
      this.form.invoiceClassId = contrcatInfo.invoiceClassId;
      this.form.contractStatus = contrcatInfo.contractStatus;
      this.form.generateTime = contrcatInfo.generateTime;
      this.form.signTime = contrcatInfo.signTime;
      if (contrcatInfo.fileEntity) {
        const fileEntity = contrcatInfo.fileEntity;
        this.form.fileId = fileEntity.fileId;
        this.fileList = [
          {
            name: fileEntity.fileName,
            url: fileEntity.filePath,
          },
        ];
      }

      this.visible = true;
      this.getInvoiceClassList();
    },
    close() {
      this.$refs.form.resetFields();
      this.visible = false;
    },
    handleRemove() {
      this.form.fileId = '';
    },
    handleUpload(params) {
      const formData = new FormData();
      formData.append('file', params.file);
      formData.append('fileName', params.file.name);

      api
        .uploadTick({
          params: {
            data: formData,
          },
        })
        .then((res) => {
          const fileId = res;
          this.form.fileId = fileId;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    handleCancel() {
      this.close();
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = Object.assign({}, this.form);
          delete data.timeRang;

          const timeRang = this.form.timeRang;
          data.contractBegin = new Date(timeRang[0]).getTime();
          data.contractEnd = new Date(timeRang[1]).getTime();

          this.$emit('confirm', data);
        }
      });
    },
    handleLoadMore() {
      this.classPage.index += 1;
      tis.this.getInvoiceClassList();
    },
    getInvoiceClassList() {
      const params = {
        invoiceClassStatus: -1,
        serviceItemId: '',
      };
      Object.assign(params, this.classPage);
      params.index -= 1;

      api
        .getInvoiceClassList({
          params: {
            params,
          },
        })
        .then((res) => {
          this.invoiceClassList = res.data;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.edit-enterpise {
  /deep/ .el-dialog__body {
    padding: 20px 20px 0px;
  }
  /deep/ .el-date-editor.el-input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contractManage/components/editEnterpise.vue